import React, { MouseEventHandler } from "react";
import { Card } from "../utils/types";
import BackImage from "../assets/images/background.png";
export default function ImageCard({
  card,
  clickHandler,
}: {
  card: Card;
  clickHandler: Function;
}) {
  return (
    <section
      className={`image-card-container ${card.isFlipping ? "flip" : ""}`}
      onClick={(e) => {
        clickHandler(card);
      }}
    >
      <div className="front">
        <img draggable={"false"} src={card.src} />
      </div>
      <div className="back">
        <img draggable={"false"} src={BackImage} />
      </div>
    </section>
  );
}
